import React, { useCallback, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ModalComponent } from '../base2';
import { Address } from '../components/profile-form/address';
import { BirthInfo } from '../components/profile-form/birth-info';
import { Race } from '../components/profile-form/race';
import { UserInfo } from '../components/profile-form/user-info';
import { IdentityContext } from '../context';
import DashboardComponent from '../demo-components/dashboard-component';

export function HomePage() {
  const person = useContext(IdentityContext);

  const subHeader = person ? 'Finish your profile' : 'Ready to start?';
  const buttonText = person ? 'Continue' : 'Let\'s Go!';

  return (
    <div>
      {/* <img src={bgSource} alt="placeholder" style={{ width: '100%' }} /> */}
      {/* <h1>The most important documents of your life</h1>
      <br />
      <br />
      <h2>{subHeader}</h2>
      <br />
      <Link to="/profiles/self">
        <Button>{buttonText}</Button>
      </Link> */}
      <DashboardComponent />
    </div>
  );
}

function ProfileFormModal() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = useCallback(() => {
    navigate('#');
  }, []);

  let component = null;

  if (location.hash === '#user-info') {
    component = <UserInfo />;
  } else if (location.hash === '#address') {
    component = <Address />;
  } else if (location.hash === '#birth-info') {
    component = <BirthInfo />;
  } else if (location.hash === '#race') {
    component = <Race />;
  }

  return (
    <ModalComponent
      closeModal={handleClose}
      contentStyle={{ height: '60%', width: '96%' }}
      showModal={!!location.hash}
    >
      {component}
    </ModalComponent>
  );
}
